module.exports = __webpack_public_path__ + "img/lettOpen.36a67fe8.svg";